#import "../fragments/tag-basic.graphql"

mutation RestoreTag($input: RestoreTagInput!) {
    restoreTag(input: $input) {
        tag {
            ...TagBasic
        }
    }
}
